/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * 
 */
export type ServiceTypeEnum = 0 | 1 | 2;

export const ServiceTypeEnum = {
    NUMBER_0: 0 as ServiceTypeEnum,
    NUMBER_1: 1 as ServiceTypeEnum,
    NUMBER_2: 2 as ServiceTypeEnum
};
